import { z } from "zod";

export const ZErrorMessage = z.object({
  type: z.literal("error"),
  code: z.number().int(),
  reason: z.string(),
  verbosity: z.number(),
});
export type ErrorMessage = z.infer<typeof ZErrorMessage>;
